import { createSignal } from '@verclam/pulsar';

const documentTypeToArchiveSignal = createSignal<number | null>(null);

export const setDocumentTypeToArchive = (documentTypeId: number | null): void => {
	documentTypeToArchiveSignal.value = documentTypeId;
};

export default documentTypeToArchiveSignal;
